<template>
    <div>
        <game-detail :details='details'></game-detail>
    </div>
</template>

<script>
import gameDetail from '../../components/gamedetail/gamedetail'

import logo_img from '../../images/xianlaigame/xl_gx.png'
import ercodeimg from '../../images/gamecenter_ercode/ercode_gx.png'
import list_img1 from '../../images/download/down-gx1.jpg'
import list_img2 from '../../images/download/down-gx2.jpg'
import list_img3 from '../../images/download/down-gx3.jpg'
export default {
    data(){
        return{
            details:{
                logo_img:logo_img,
                name:'山水广西麻将',
                size:'119.98',
                load_count:'326',
                desp:'山水广西麻将是款水墨风格主打广西省主流玩法的麻将游戏，现囊括了柳州、南宁、贵港、百色等城市主流玩法，其界面唯美，玩法完全还原当地特色，深受广大广西人们的喜爱。',
                ios_url:'http://app6.auwvnd.cn/?downloadfrom=guangxi',
                android_url:'http://app6.auwvnd.cn/?downloadfrom=guangxi',
                ercodeimg:ercodeimg,
                list_img1:list_img1,
                list_img2:list_img2,
                list_img3:list_img3,
                cut_img1:''
            }
        }
    },
    components:{
        gameDetail
    }
}
</script>

<style scoped>

</style>
